import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getTicketDetails, updateTicket, addTicketComment } from '../../api/ticketApi';
import { useAuth } from '../../context/AuthContext';
import TicketDetail from '../../components/Tickets/TicketDetail';
import Loading from '../../components/Common/Loading';
import ErrorMessage from '../../components/Common/ErrorMessage';
import './TicketDetailPage.css';

export default function TicketDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();  // ✅ Get current user
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTicketDetails();
  }, [id]);

  const fetchTicketDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getTicketDetails(id, user?.role);  // ✅ Pass role
      setTicket(response.ticket);
    } catch (err) {
      setError(err.response?.data?.msg || 'Failed to load ticket details');
    } finally {
      setLoading(false);
    }
  };

const handleUpdate = async (data, role) => {
  try {
    await updateTicket(id, data, role);
    alert('Ticket updated successfully!');
    fetchTicketDetails();
  } catch (err) {
    alert(err.response?.data?.msg || 'Failed to update ticket');
  }
};

const handleAddComment = async (comment, attachment, role) => {
  try {
    await addTicketComment(id, comment, attachment, role);
    alert('Comment added successfully!');
    fetchTicketDetails();
  } catch (err) {
    alert(err.response?.data?.msg || 'Failed to add comment');
  }
};

  if (loading) {
    return <Loading message="Loading ticket details..." />;
  }

  if (error) {
    return (
      <div className="ticket-detail-page">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <ErrorMessage message={error} onRetry={fetchTicketDetails} />
      </div>
    );
  }

  return (
    <div className="ticket-detail-page">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back to Tickets
      </button>
      <TicketDetail
        ticket={ticket}
        onUpdate={handleUpdate}
        onAddComment={handleAddComment}
        canEdit={true}
      />
    </div>
  );
}
